import { ReactElement } from "react";
import { FontIconName, TransparentButtonList } from "client/Components";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { generateTrackingId, setTrackingId } from "client/Misc/utils";
import {
	CustomNotificationDataViewModel,
	CustomNotificationActionKind,
	CustomNotificationActionViewModel
} from "client/Api/Notifications/notifications";

export type CustomActivityProps = {
	data: CustomNotificationDataViewModel;
};

const actionKindToIconMap: { [key in CustomNotificationActionKind]: FontIconName } = {
	[CustomNotificationActionKind.Check]: "check",
	[CustomNotificationActionKind.Cancel]: "xmark",
	[CustomNotificationActionKind.Add]: "plus",
	[CustomNotificationActionKind.Open]: "folder-open",
	[CustomNotificationActionKind.Edit]: "pen",
	[CustomNotificationActionKind.Manage]: "wrench",
	[CustomNotificationActionKind.Delete]: "trash-can",
	[CustomNotificationActionKind.Forward]: "share",
	[CustomNotificationActionKind.Backward]: "reply"
};

export const CustomActivity = (props: CustomActivityProps): ReactElement => {
	const { data } = props;

	const clickHandler = (action: CustomNotificationActionViewModel): void => {
		navigateTo(action.url, true);
	};

	const {
		title,
		actions
	} = data;

	return (
		<>
			<span {...setTrackingId("title")}>
				{title}
			</span>
			{actions?.length > 0 && (
				<TransparentButtonList responsiveBehavior="wrap">
					{actions.map((x, i) => (
						<TransparentButtonList.Item
							key={i}
							icon={actionKindToIconMap[x.kind]}
							text={x.title}
							onClick={() => clickHandler(x)}
							bubbleClick={false}
							trackingId={generateTrackingId("custom-action", `|${i}`)}
						/>
					))}
				</TransparentButtonList>
			)}
		</>
	);
};

CustomActivity.displayName = "CustomActivity";